import { SimpleMarkdown } from '@/components/FAQs/SimpleMarkdown';
import BenefitIcon, { type BenefitIconType } from '@/components/Icons/Benefits/BenefitIcon';
import type { Benefits } from '@/types/referAndEarn';
const CreatorBenefits = ({
  benefits
}: {
  benefits: Benefits;
}) => <section className="special-page-container flex flex-col gap-5 rounded-2xl py-5 sm:items-center sm:rounded-[32px] md:py-10 md:pb-0 xl:pb-10 2xl:gap-10" data-sentry-component="CreatorBenefits" data-sentry-source-file="CreatorBenefits.tsx">
    <div className="self-start text-2xl">
      <h2 className="font-semibold text-2xl 2xl:text-3xl">Benefits</h2>
    </div>
    <ul className="grid list-none grid-cols-1 gap-y-4 max-md:w-full md:w-full md:grid-cols-2 md:gap-x-5 md:gap-y-5">
      {benefits.map(benefit => <li className="relative flex w-full items-center gap-4 rounded-lg p-4 max-md:bg-gray-50 md:gap-3 md:px-0 max-md:dark:bg-gray-900" key={benefit.description}>
          <BenefitIcon className="aspect-square size-14 shrink-0 object-contain md:size-24" type={benefit.icon as BenefitIconType} />
          <SimpleMarkdown className="flex whitespace-pre-wrap text-pretty text-left text-sm md:text-base [&_p]:font-normal [&_p]:font-sans [&_p]:text-gray-700 dark:[&_p]:text-gray-200 [&_strong]:font-semibold [&_strong]:text-pink-600 dark:[&_strong]:text-pink-400">
            {benefit.description}
          </SimpleMarkdown>
        </li>)}
    </ul>
  </section>;
export default CreatorBenefits;